<template>

  <el-dialog title="是否主管"  @close="handleClose" :visible.sync="centerDialogVisible">
     <div>
      <el-radio-group v-model="flag">
        <el-radio :label="1" style="margin-right:48px">是</el-radio>
        <el-radio :label="0">否</el-radio>
       
      </el-radio-group>
     </div>

    <span slot="footer">
      <el-button  @click="centerDialogVisible = false" style="margin-right:8px;">取 消</el-button>
      <el-button  type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { isLeader } from '@/api/system'
  export default {
    props: ['changeId'],
    data() {
      return {
        flag:0,
        centerDialogVisible: true,
        id:this.changeId
      }
    },
    mounted() {
     
    },
    methods: {
      handleClose: function () {
        this.$emit('closeDialog', false)
      },
      sure(){
        isLeader({
          ids:this.id,	
          adminFlag:this.flag
        }).then(res=>{
          if(res&&res.code==0){
            this.$emit('closeDialog', false)
          }else{

          }
        })
      }
    
    }
  }
</script>
<style lang="scss" scoped>
  /deep/.el-dialog__body {
    overflow: hidden;
    margin-bottom: -5px !important;
  }

  .enter {
    top: 0px !important;
  }

  .leave {
    top: 34px !important;
  }

  .tipIcon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-size: contain;
    background-image: url("../../../../assets/Shape.png");
    margin-right: 8px;
    position: relative;
    top: 3px;
  }

  .mt10 {
    margin-top: 10px !important;
    float: right;
    margin-bottom:32px;
  }

  /deep/.el-dialog__footer {
    /* padding-top: 30px; */
  }

  .addtip {
    background-color: #FFFAF5;
    padding: 8px 0px 8px 16px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    position: absolute;
    top: -9px;
    width: 100%;
   
  }

  .addFade-enter,
  .addFade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  /* v-enter-active 【入场动画的时间段】 */
  /* v-leave-active 【离场动画的时间段】 */
  .addFade-enter-active,
  .addFade-leave-active {
    transition: all 0.5s ease;
  }

  .data {
    color: #FFA940;
  }

  /deep/.el-table td {
    padding: 0px !important;
  }
  .tableAnimate {
  margin: 0 auto;
  position: relative;
  top:0px;
  transition: all  0.3s ease;
}
/deep/.el-dialog__header{
  border-bottom: none;
}
/deep/.el-dialog{
  width:500px;
  height:200px;
  margin-top:30vh;

}
/deep/.el-dialog__footer{
  border-top:none;
  padding: 63px 16px 8px 0px;

}
</style>